import * as React from 'react';
import classnames from 'classnames';

const SelectWrapper = ({ children , className ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('select-wrapper', className)
    }, children)
;

export { SelectWrapper };
//# sourceMappingURL=SelectWrapper.js.map
